export default "__VITE_ASSET__BEqWkcD___"